export const ContentEditorialCredits = [
    // Header section
    { span: 7, height: "28px", classes: "marginTop-8" }, // Main header

    {
        classes: "marginTop-12",
        columns: [
            { span: 7, height: "120px" },
            { span: 8, height: "120px", classes: "marginLeft-12" },
        ],
    },
]
